import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import authenticationReducer from './authSlice';
import promptsReducer from './promptsSlice';
import messagesReducer from './messagesSlice';

export const store = configureStore({
  reducer: {
    prompts: promptsReducer,
    authentication: authenticationReducer,
    messages: messagesReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
